export default __webpack_public_path__ + "static/media/times.da5c4222.svg";